var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveInstitutions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662539651759,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 17822,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.1 543.2H72.7c-5.1 0-8.5-3.4-8.5-8.5v-22.1c0-5.1 3.4-8.5 8.5-8.5H134c6.8 0 10.2-8.5 6.8-13.6-23.8-45.8-37.4-90-37.4-137.5 0-125.6 97-222.4 224.6-222.4 66.4 0 132.8 28.9 177 81.5 5.1 3.4 10.2 3.4 13.6 0 44.2-49.2 110.6-78.1 177-78.1 125.9 0 224.6 96.7 224.6 222.4 0 64.5-25.5 125.6-69.8 186.7-1.7 1.7-3.4 3.4-6.8 3.4H668.3c-3.4 0-5.1 1.7-6.8 3.4l-45.9 56c-5.1 6.8-13.6 3.4-15.3-3.4l-57.9-286.9c-1.7-10.2-13.6-10.2-17-1.7l-68.1 219c-3.4 8.5-13.6 8.5-17 0l-40.8-122.2c-1.7-8.5-11.9-8.5-15.3-1.7l-68.1 134.2z",
    "p-id": 17823,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M950.8 583.9c5.1 0 8.5 3.4 8.5 10.2v22.1c0 5.1-3.4 8.5-8.5 8.5H782.3c-3.4 0-5.1 1.7-6.8 3.4-56.1 57.7-125.9 120.5-207.6 191.8l-51.1 50.9c-1.5 1.6-3.7 2.6-6 2.6s-4.4-0.9-6-2.6l-51-50.9c-95.3-83.2-175.3-154.5-234.9-220.7-5.1-6.8 0-15.3 6.8-15.3h108.9c3.4 0 6.8-1.7 8.5-5.1l37.4-78.1c1.7-6.8 11.9-6.8 15.3 0L440 622.9c3.4 6.8 13.6 6.8 17 0l59.6-154.5c3.4-6.8 15.3-6.8 17 1.7L588 668.7c1.7 6.8 10.2 8.5 15.3 3.4l68.1-84.9c1.7-1.7 3.4-3.4 6.8-3.4h272.6z",
    "p-id": 17824,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInstitutions);
export default __webpack_public_path__ + "static/media/activeInstitutions.d752318d.svg";
export { ForwardRef as ReactComponent };